import { render } from "./JoinCodeQR.vue?vue&type=template&id=75b128a9&scoped=true"
import script from "./JoinCodeQR.vue?vue&type=script&lang=js"
export * from "./JoinCodeQR.vue?vue&type=script&lang=js"

import "./JoinCodeQR.vue?vue&type=style&index=0&id=75b128a9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\bfern\\Documents\\la-vuelta-trama\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75b128a9"]])

export default __exports__